import React, { forwardRef } from 'react';
import { FILTER_BY_MAP, usePracticas } from './hooks/usePracticas';
import { PracticasAutocomplete } from './PracticasAutocomplete';

export const PracticasOrdenConsultaAutocomplete = forwardRef(
  ({ value, error, onChangeEvent, ...props }, ref) => {
    const { loading, options } = usePracticas({
      filterByAPI: FILTER_BY_MAP['byOrdenesConsultas'],
    });

    const properties = {
      ...props,
      value,
      error,
      loading,
      options,
      onChangeEvent,
    };

    return <PracticasAutocomplete {...properties} />;
  },
);
